import { AxiosError } from 'axios';
import { useAlert } from 'react-alert';

import { useMutation } from '@tanstack/react-query';
import {
  ContactName, initiateContactVerification, InitiateContactVerificationErrorOutput,
  rewriteUserContactByName, verifyContact, VerifyContactErrorOutput, VerifyContactOutput
} from '@uplift/api';

export const useVerifyContact = () => {
  const mutation = useMutation<VerifyContactOutput, AxiosError<VerifyContactErrorOutput>, { contactId: string; verificationCode: string }>(
    async (args) => {
      const response = await verifyContact(args.contactId, {
        verification_code: args.verificationCode,
      });

      return response;
    }
  );

  return {
    error: mutation.error?.response?.data,
    verifyContact: mutation.mutateAsync,
  };
};


export const useInitiateContactVerification = () => {
  const alert = useAlert();
  const mutation = useMutation({
    mutationFn: async (args: { contactId: string }) => {
      return await initiateContactVerification(args.contactId);
    },
    onError: (error: AxiosError<InitiateContactVerificationErrorOutput>) => {
      if (error.response?.status === 429) {
        alert.error('<strong>Too many attempts.</strong> Wait 1 minute to send a new code.');
      } else {
        alert.error('An unknown error occurred');
      }
    },
  });

  return {
    initiateContactVerificationLoading: mutation.isLoading,
    initiateContactVerificationData: mutation.data,
    initiateContactVerification: mutation.mutateAsync,
  };
};

export const useUpdateMobileNumber = () => {
  const mutation = useMutation(async (args: { userId: string; name: ContactName; number: string }) => {
    return rewriteUserContactByName(args.userId, { name: args.name, number: args.number });
  });

  return {
    updateMobileNumber: mutation.mutateAsync,
  };
};
